(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["accordion-item-aquas"] && !Shopify.designMode) return;
  try {
    // Auto-close other accordions when one opens (single mode)
  document.addEventListener('DOMContentLoaded', function() {
    const accordions = document.querySelectorAll('[data-accordion]');
    
    accordions.forEach(function(accordion) {
      const mode = accordion.dataset.accordionMode || 'single';
      
      if (mode === 'single') {
        accordion.addEventListener('toggle', function(e) {
          if (e.target.tagName === 'DETAILS' && e.target.open) {
            const allDetails = accordion.querySelectorAll('details.accordion__item');
            allDetails.forEach(function(details) {
              if (details !== e.target && details.open) {
                details.open = false;
              }
            });
          }
        }, true);
      }
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-localization"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    // Language selector
    const localeButton = document.querySelector('.aquas-locale-button');
    const localeDropdown = document.querySelector('.aquas-locale-dropdown');
    
    if (localeButton && localeDropdown) {
      localeButton.addEventListener('click', function() {
        const isExpanded = this.getAttribute('aria-expanded') === 'true';
        this.setAttribute('aria-expanded', !isExpanded);
        localeDropdown.hidden = isExpanded;
      });
    }

    // Currency selector
    const currencyButton = document.querySelector('.aquas-currency-button');
    const currencyDropdown = document.querySelector('.aquas-currency-dropdown');
    
    if (currencyButton && currencyDropdown) {
      currencyButton.addEventListener('click', function() {
        const isExpanded = this.getAttribute('aria-expanded') === 'true';
        this.setAttribute('aria-expanded', !isExpanded);
        currencyDropdown.hidden = isExpanded;
      });
    }

    // Close dropdowns when clicking outside
    document.addEventListener('click', function(event) {
      if (localeButton && !localeButton.closest('.aquas-locale-selector').contains(event.target)) {
        localeButton.setAttribute('aria-expanded', 'false');
        if (localeDropdown) localeDropdown.hidden = true;
      }
      if (currencyButton && !currencyButton.closest('.aquas-currency-selector').contains(event.target)) {
        currencyButton.setAttribute('aria-expanded', 'false');
        if (currencyDropdown) currencyDropdown.hidden = true;
      }
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["image-zoom-modal-aquas"] && !Shopify.designMode) return;
  try {
    // Image Zoom Modal functionality
  (function () {
    // Store for modal states
    const modalStates = {};

    // Initialize modal
    function initModal(modalId) {
      const dataEl = document.getElementById(modalId + 'Data');
      if (!dataEl) return null;

      try {
        const images = JSON.parse(dataEl.textContent);
        modalStates[modalId] = {
          images: images,
          currentIndex: 0,
        };
        return modalStates[modalId];
      } catch (e) {
        console.error('Failed to parse image data:', e);
        return null;
      }
    }

    // Open modal at specific index
    window.openImageZoom = function (modalId, index) {
      const dialog = document.getElementById(modalId + 'Dialog');
      if (!dialog) return;

      let state = modalStates[modalId];
      if (!state) {
        state = initModal(modalId);
      }
      if (!state || !state.images.length) return;

      state.currentIndex = index || 0;
      updateZoomImage(modalId);
      dialog.showModal();
    };

    // Update displayed image
    function updateZoomImage(modalId) {
      const state = modalStates[modalId];
      if (!state) return;

      const img = document.getElementById(modalId + 'Image');
      const currentEl = document.getElementById(modalId + 'Current');

      if (img && state.images[state.currentIndex]) {
        img.src = state.images[state.currentIndex].src;
        img.alt = state.images[state.currentIndex].alt;
      }

      if (currentEl) {
        currentEl.textContent = state.currentIndex + 1;
      }
    }

    // Navigate images
    function navigateZoom(modalId, direction) {
      const state = modalStates[modalId];
      if (!state) return;

      state.currentIndex += direction;

      // Loop around
      if (state.currentIndex < 0) {
        state.currentIndex = state.images.length - 1;
      }
      if (state.currentIndex >= state.images.length) {
        state.currentIndex = 0;
      }

      updateZoomImage(modalId);
    }

    // Click handlers for navigation
    document.addEventListener('click', function (e) {
      const navBtn = e.target.closest('[data-zoom-nav]');
      if (navBtn) {
        const direction = parseInt(navBtn.dataset.zoomNav);
        const modalId = navBtn.dataset.modalId;
        navigateZoom(modalId, direction);
      }
    });

    // Keyboard navigation
    document.addEventListener('keydown', function (e) {
      // Find open dialog
      const openDialog = document.querySelector('.zoom-dialog[open]');
      if (!openDialog) return;

      const modalId = openDialog.id.replace('Dialog', '');

      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        navigateZoom(modalId, -1);
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        navigateZoom(modalId, 1);
      }
    });

    // Close on backdrop click
    document.querySelectorAll('.zoom-dialog').forEach(function (dialog) {
      dialog.addEventListener('click', function (e) {
        if (e.target === this) {
          this.close();
        }
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card-aquas"] && !Shopify.designMode) return;
  try {
    // Quick Add to Cart functionality
  // Integrates with Dawn theme's cart-notification system
  document.addEventListener('click', function (e) {
    const quickAddBtn = e.target.closest('.product-card__quick-add:not(.product-card__quick-add--disabled)');
    if (!quickAddBtn) return;

    e.preventDefault();
    e.stopPropagation();

    const variantId = quickAddBtn.dataset.variantId;
    if (!variantId) return;

    // Add loading state
    quickAddBtn.disabled = true;
    const originalText = quickAddBtn.textContent;
    quickAddBtn.textContent = '...';

    // Add to cart via Shopify AJAX API
    // Uses sections parameter to get updated cart sections for notification
    const sectionsToRender = [
      {
        section: document.getElementById('cart-notification-product')?.dataset.sectionId || 'cart-notification-product',
      },
      {
        section: document.getElementById('cart-notification-button')?.dataset.sectionId || 'cart-notification-button',
      },
      {
        section: document.getElementById('cart-icon-bubble')?.dataset.sectionId || 'cart-icon-bubble',
      },
    ];

    const formData = {
      items: [
        {
          id: variantId,
          quantity: 1,
        },
      ],
      sections: sectionsToRender.map((section) => section.section).join(','),
      sections_url: window.location.pathname,
    };

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        quickAddBtn.textContent = '✓';

        // Fetch updated cart to get new total
        return fetch('/cart.js')
          .then(function (r) {
            return r.json();
          })
          .then(function (cart) {
            var cartTotal = document.getElementById('cart-total-price');
            if (cartTotal) {
              var amount = (cart.total_price / 100).toFixed(2).replace('.', ',');
              cartTotal.textContent = '\u20AC' + amount;
            }
          });
      })
      .then(function () {
        setTimeout(function () {
          quickAddBtn.textContent = originalText;
          quickAddBtn.disabled = false;
        }, 1500);
      })
      .catch(function (error) {
        console.error('Error adding to cart:', error);
        quickAddBtn.textContent = originalText;
        quickAddBtn.disabled = false;
      });
  });

  // Wishlist functionality - placeholder for future implementation
  document.addEventListener('click', function (e) {
    const wishlistBtn = e.target.closest('.product-card__wishlist');
    if (!wishlistBtn) return;

    e.preventDefault();
    e.stopPropagation();

    // TODO: Implement wishlist functionality
    // For now, just toggle the icon
    const icon = wishlistBtn.querySelector('.product-card__wishlist-icon');
    if (icon.textContent === '♡') {
      icon.textContent = '♥';
      wishlistBtn.classList.add('is-active');
    } else {
      icon.textContent = '♡';
      wishlistBtn.classList.remove('is-active');
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["trust-signals-aquas"] && !Shopify.designMode) return;
  try {
    // Share menu toggle functionality
  document.addEventListener('click', function (e) {
    const shareToggle = e.target.closest('[data-share-toggle]');
    const shareMenu = document.querySelector('[data-share-menu]');

    if (shareToggle && shareMenu) {
      e.preventDefault();
      shareMenu.classList.toggle('share-menu--open');
      return;
    }

    // Close menu when clicking outside
    if (shareMenu && !e.target.closest('.share-menu')) {
      shareMenu.classList.remove('share-menu--open');
    }
  });

  // Copy link functionality
  document.addEventListener('click', function (e) {
    const copyBtn = e.target.closest('[data-copy-link]');
    if (!copyBtn) return;

    e.preventDefault();
    const url = copyBtn.dataset.copyLink;

    navigator.clipboard
      .writeText(url)
      .then(function () {
        copyBtn.setAttribute('data-copied', 'true');
        setTimeout(function () {
          copyBtn.removeAttribute('data-copied');
        }, 2000);
      })
      .catch(function (err) {
        console.error('Failed to copy:', err);
      });
  });

  // Close on escape key
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      const shareMenu = document.querySelector('[data-share-menu].share-menu--open');
      if (shareMenu) {
        shareMenu.classList.remove('share-menu--open');
      }
    }
  });
  } catch(e) { console.error(e); }
})();

})();
